export const isOffline = 'OFFLINE'

export const storyPaginationSize = 99999